
type Dict<T> = Partial<Record<string, T>>;
type DictType<TDict> = TDict extends Dict<infer T> ? T : never;

export const fastMapValues = <T extends Dict<unknown>, U>(
  obj: T,
  mapFn: (item: DictType<T>, key: keyof typeof obj) => U,
): { [K in keyof typeof obj]: U } => {
  const keys = Object.keys(obj);
  const mapped = {} as { [K in keyof typeof obj]: U };
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i] as keyof typeof obj;
    mapped[key] = mapFn(obj[key] as DictType<T>, key);
  }
  return mapped;
};
